// @flow

import React from 'react';

import { type UserInputValues, type SetUserInputValue } from './types';

export const UserInputValuesContext = React.createContext<?[UserInputValues, SetUserInputValue]>(null);
